
import React, { FunctionComponent } from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import { LoadingPlaceholder } from '../loading-content/LoadingPlaceholder';
import { LoadingContent } from '../loading-content/LoadingContent';

import IconAgeLimit from 'src/assets/Icons/AgeLimit.svg';

import locale from './locale';

const style = require('./AgeLimit.css');

interface Props {
  eventData: any;
  isMobile: boolean;
  loading: boolean;
}

const AgeLimitPlaceholder = () => (
  <LoadingPlaceholder modifierClass={style.container}>
    <LoadingContent height='24px' width='24px'/>
    <LoadingContent height='24px' width='400px'/>
  </LoadingPlaceholder>
);

const AgeLimitComponent: FunctionComponent<Props & InjectedIntlProps> = ({
  eventData,
  isMobile,
  loading,
  intl: { formatMessage },
}) => {
  if (loading) return <AgeLimitPlaceholder />;
  if (!eventData.ageLimit) return <></>
  return (
    <div className={style.container}>
      <IconAgeLimit />
      <div className={style.textContainer}>
        <div className={style.label}>{formatMessage(locale.ageLimit)}</div>
        <div className={style.ageLimit}>{eventData.ageLimit}</div>
      </div>
    </div> 
  )
}

export const AgeLimit = injectIntl(AgeLimitComponent);
